import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

@ValidatorConstraint({ name: "is ABA" })
export class IsABAValidator implements ValidatorConstraintInterface {
    public validate(rawABA: string): boolean {
        if (!rawABA) {
            return false;
        }

        const len = rawABA.trim().length;
        const isCorrectLength = len === 9;

        const areAllDigits = /^[0-9]{9}$/.test(rawABA.trim());

        return isCorrectLength && areAllDigits;
    }

    public defaultMessage(): string {
        return "ABA is in wrong format.";
    }
}
